import axios from 'axios';
import { CONFIG } from '../config/config';
import { getToken } from './auth';

export interface OrgMetricThreshold {
  id: number;
  name?: string | null;
  description?: string | null;
  review_dimension?: string | null;
  lower_bound?: number | null;
  upper_bound?: number | null;
  metrics_type?: string | null;
  value_type?: string | null;
  effective_start_date?: string | null;
  effective_end_date?: string | null;
  overridable?: boolean | null;
  is_critical?: boolean | null;
  is_dashboard_metric?: boolean | null;
  target_value?: number | null;
  unit_of_measure?: string | null;
  /** Finest metric_level.id for compute; null = all grains on the entity chain */
  first_applicable_metric_level_id?: number | null;
  first_applicable_metric_level_name?: string | null;
  first_applicable_metric_level_display_label?: string | null;
  updated_at?: string | null;
}

export interface UpdateOrgMetricThreshold {
  id: number;
  name?: string | null;
  description?: string | null;
  review_dimension?: string | null;
  lower_bound?: number | null;
  upper_bound?: number | null;
  metrics_type?: string | null;
  value_type?: string | null;
  effective_start_date?: string | null;
  effective_end_date?: string | null;
  overridable?: boolean | null;
  is_critical?: boolean | null;
  is_dashboard_metric?: boolean | null;
  target_value?: number | null;
  unit_of_measure?: string | null;
  first_applicable_metric_level_id?: number | null;
}

const API_BASE_URL = CONFIG.SERVER_URL;

const getAuthHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  'Content-Type': 'application/json'
});

export const orgMetricThresholdService = {
  getAllOrgMetricThresholds: async (): Promise<OrgMetricThreshold[]> => {
    const response = await axios.get(
      `${API_BASE_URL}/get_all_org_metric_thresholds`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  updateOrgMetricThreshold: async (
    data: UpdateOrgMetricThreshold
  ): Promise<OrgMetricThreshold> => {
    const response = await axios.put(
      `${API_BASE_URL}/update_org_metric_threshold`,
      data,
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  getOrgMetricThresholdHistory: async (
    name: string,
    currentId: number
  ): Promise<OrgMetricThreshold[]> => {
    const response = await axios.get(
      `${API_BASE_URL}/get_org_metric_threshold_history`,
      {
        params: {
          name,
          current_id: currentId
        },
        headers: getAuthHeaders()
      }
    );
    return response.data;
  }
};